import { forwardRef } from "react";
import PropTypes from "prop-types";
import Slide from "@mui/material/Slide";
import { Button } from "@mindlercare/ui-web";

import {
  AlertDialog,
  AlertDialogInnerContainer,
  ButtonDiv,
  ButtonSeparator,
  DialogTitleText,
} from "../booking/booking.styles";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
Transition.displayName = "Transition";
export default function ConfirmDialog(props) {
  return (
    <AlertDialog open={props.modalConfirm} TransitionComponent={Transition}>
      <AlertDialogInnerContainer>
        <DialogTitleText variant="h3">{props.confirmSlot}</DialogTitleText>
        <ButtonDiv>
          <Button onClick={props.cancelDial} variant="secondary">
            <p>{props.cancel}</p>
          </Button>
          <ButtonSeparator>
            <Button onClick={props.confirmDial} variant="primary">
              <p>{props.confirm}</p>
            </Button>
          </ButtonSeparator>
        </ButtonDiv>
      </AlertDialogInnerContainer>
    </AlertDialog>
  );
}

ConfirmDialog.propTypes = {
  modalConfirmation: PropTypes.bool,
  alertDialog: PropTypes.string,
  cancelDial: PropTypes.func,
  modalConfirm: PropTypes.bool,
  alertDialogInnerContainer: PropTypes.string,
  confirmSlot: PropTypes.string,
  buttonDiv: PropTypes.string,
  cancelButton: PropTypes.string,
  cancel: PropTypes.string,
  confirmDial: PropTypes.func,
  confirm: PropTypes.string,
};
